<template lang="pug">
  div
    v-text-field(
      v-model="model"
      :label="label"
      :color="color"
      :disabled="disabled"
      :prepend-icon="prependIcon"
      :error-messages="errorMessages"
      :clearable="clearable"
      :multiple="multiple"
      @click.stop="pickFile"
      @blur="$emit('blur', $event)"
    )
    input(type="file" style="display: none" ref="image" :accept="accept" :multiple="multiple" @change="onFilePicked")

</template>

<script>
import vmodelMixin from '@/mixins/v-model-for-custom-input-controls.js'

export default {
  mixins: [ vmodelMixin ],
  props: {
    accept: String,
    multiple: Boolean,
    clearable: Boolean,
    prependIcon: {
      type: String,
      default: 'attach_file'
    }
  },
  methods: {
    pickFile () {
      this.$refs.image.click()
    },
    onFilePicked (event) {
      const files = event.target.files
      const fileNames = []
      for (let i = 0, len = files.length; i < len; i++) {
        const file = files.item(i)
        fileNames.push(file.name)
      }
      this.$emit('change', event)
      this.$emit('change-files', Array.from(files))
      setTimeout(() => { this.model = fileNames.join(', ') })
    }
  }
}
</script>
